// import React, { useState, useEffect } from "react";
// import { Button, TextField, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
// import { Box, Grid, Typography, Divider } from "@mui/material";

// const OTTFingerprint = (props) => {
//   const [formValues, setFormValues] = useState({
//     category: "",
//     fontSize: "",
//     layout: "",
//     fontColor: "",
//     size: "",
//     position: "",
//     content: "",
//     number: "",
//   });

//   const [categories, setCategories] = useState([]);
//   const [layouts, setLayouts] = useState([]);
//   const [fontSizes, setFontSizes] = useState([]);
//   const [fontColors, setFontColors] = useState([]);

//   useEffect(() => {
//     setCategories([
//       { id: "movies", name: "Movies" },
//       { id: "sports", name: "Sports" },
//       { id: "news", name: "News" },
//     ]);

//     setLayouts([
//       { id: "full_screen", name: "Full Screen" },
//       { id: "watermark", name: "Watermark" },
//     ]);

//     setFontSizes([
//       { id: "small", label: "Small" },
//       { id: "medium", label: "Medium" },
//       { id: "large", label: "Large" },
//     ]);

//     setFontColors([
//       { id: "red", label: "Red" },
//       { id: "green", label: "Green" },
//       { id: "blue", label: "Blue" },
//     ]);
//   }, []);

//   const handleChange = (event) => {
//     setFormValues({ ...formValues, [event.target.name]: event.target.value });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
  
//     const requestBody = {
//       category: formValues.category,
//       layout: formValues.layout,
//       fontSize: formValues.fontSize, // Ensure this is a string
//       fontColor: formValues.fontColor,
//       size: parseInt(formValues.size, 10), // Convert to integer
//       position: formValues.position,
//       content: formValues.content,
//       number: parseInt(formValues.number, 10), // Convert to integer
//     };
  
//     try {
//       const response = await fetch("http://35.207.239.207:8080/api/fingerprints", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
  
//       const responseText = await response.text(); // Read response as text
  
//       console.log("API Response:", responseText); // Log raw response (hex value)
  
//       if (!response.ok) {
//         throw new Error(`Error: ${response.status} ${response.statusText} - ${responseText}`);
//       }
  
//       alert(`Fingerprint added successfully! Hex Value: ${responseText}`);
  
//       props.handleClose(); // Close the modal if successful
//     } catch (error) {
//       console.error("Failed to submit fingerprint:", error);
//       alert("Failed to submit fingerprint. Please try again.");
//     }
//   };
  
  

//   return (
//     <Box sx={{ padding: 3, borderRadius: 2, maxWidth: 600, margin: "auto" }}>
     
//      <form onSubmit={handleSubmit}>
//         <Grid container spacing={2}>
//           <Grid item xs={6}>
//             <FormControl fullWidth>
//               <InputLabel>Category</InputLabel>
//               <Select name="category" value={formValues.category} onChange={handleChange}>
//                 {categories.map((category) => (
//                   <MenuItem key={category.id} value={category.id}>
//                     {category.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={6}>
//             <FormControl fullWidth>
//               <InputLabel>Font Size</InputLabel>
//               <Select name="fontSize" value={formValues.fontSize} onChange={handleChange}>
//                 {fontSizes.map((size) => (
//                   <MenuItem key={size.id} value={size.id}>
//                     {size.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={6}>
//             <FormControl fullWidth>
//               <InputLabel>Layout</InputLabel>
//               <Select name="layout" value={formValues.layout} onChange={handleChange}>
//                 {layouts.map((layout) => (
//                   <MenuItem key={layout.id} value={layout.id}>
//                     {layout.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={6}>
//             <FormControl fullWidth>
//               <InputLabel>Font Color</InputLabel>
//               <Select name="fontColor" value={formValues.fontColor} onChange={handleChange}>
//                 {fontColors.map((color) => (
//                   <MenuItem key={color.id} value={color.id}>
//                     {color.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Size"
//               type="number"
//               name="size"
//               value={formValues.size}
//               onChange={handleChange}
//             />
//           </Grid>

//           <Grid item xs={6}>
//             <FormControl fullWidth>
//               <InputLabel>Position</InputLabel>
//               <Select name="position" value={formValues.position} onChange={handleChange}>
//                 <MenuItem value="top">Top</MenuItem>
//                 <MenuItem value="bottom">Bottom</MenuItem>
//                 <MenuItem value="left">Left</MenuItem>
//                 <MenuItem value="right">Right</MenuItem>
//                 <MenuItem value="center">Center</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Content"
//               multiline
//               rows={3}
//               name="content"
//               value={formValues.content}
//               onChange={handleChange}
//             />
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Number"
//               type="number"
//               name="number"
//               value={formValues.number}
//               onChange={handleChange}
//             />
//           </Grid>
//         </Grid>

//         <Box sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}>
//           <Button type="submit" variant="contained" color="primary" sx={{ marginRight: 2 }}>
//             Submit
//           </Button>
//           <Button variant="outlined" color="secondary" onClick={props.handleClose}>
//             Cancel
//           </Button>
//         </Box>
//       </form>
//     </Box>
//   );
// };

// export default OTTFingerprint;




import React, { useState, useEffect } from "react";
import { Button, TextField, Select, MenuItem, FormControl, InputLabel, Box, Grid, Snackbar, Alert,AlertColor } from "@mui/material";

const API_URL = `${process.env.REACT_APP_BASE_API_URL}/api/fingerprints`;

const OTTFingerprint = (props) => {
  const [formValues, setFormValues] = useState({
    category: "",
    fontSize: "",
    layout: "",
    fontColor: "",
    size: "",
    position: "",
    content: "",
    number: "",
  });

  const [snackbar, setSnackbar] = useState<{
      open: boolean;
      message: string;
      severity: AlertColor;
    }>({
      open: false,
      message: "",
      severity: "success", 
    });

  const [categories, setCategories] = useState([]);
  const [layouts, setLayouts] = useState([]);
  const [fontSizes, setFontSizes] = useState([]);
  const [fontColors, setFontColors] = useState([]);

  useEffect(() => {
    setCategories([
      { id: "movies", name: "Movies" },
      { id: "sports", name: "Sports" },
      { id: "news", name: "News" },
    ]);

    setLayouts([
      { id: "full_screen", name: "Full Screen" },
      { id: "watermark", name: "Watermark" },
    ]);

    setFontSizes([
      { id: "small", label: "Small" },
      { id: "medium", label: "Medium" },
      { id: "large", label: "Large" },
    ]);

    setFontColors([
      { id: "red", label: "Red" },
      { id: "green", label: "Green" },
      { id: "blue", label: "Blue" },
    ]);
  }, []);

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const requestBody = {
      category: formValues.category,
      layout: formValues.layout,
      fontSize: formValues.fontSize,
      fontColor: formValues.fontColor,
      size: parseInt(formValues.size, 10),
      position: formValues.position,
      content: formValues.content,
      number: parseInt(formValues.number, 10),
    };

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText} - ${responseText}`);
      }

      setSnackbar({ open: true, message: `Fingerprint added! Hex: ${responseText}`, severity: "success" });

      props.fetchFingerprints(); // Refresh the table
      setTimeout(props.handleClose, 2000); // Close modal after 2 sec
    } catch (error) {
      console.error("Failed to submit fingerprint:", error);
      setSnackbar({ open: true, message: "Failed to add fingerprint!", severity: "error" });
    }
  };

  return (
    <Box sx={{ padding: 3, maxWidth: 600, margin: "auto" }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Category</InputLabel>
              <Select name="category" value={formValues.category} onChange={handleChange}>
                {categories.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Font Size</InputLabel>
              <Select name="fontSize" value={formValues.fontSize} onChange={handleChange}>
                {fontSizes.map((size) => (
                  <MenuItem key={size.id} value={size.id}>
                    {size.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Layout</InputLabel>
              <Select name="layout" value={formValues.layout} onChange={handleChange}>
                {layouts.map((layout) => (
                  <MenuItem key={layout.id} value={layout.id}>
                    {layout.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Font Color</InputLabel>
              <Select name="fontColor" value={formValues.fontColor} onChange={handleChange}>
                {fontColors.map((color) => (
                  <MenuItem key={color.id} value={color.id}>
                    {color.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField fullWidth label="Size" type="number" name="size" value={formValues.size} onChange={handleChange} />
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Position</InputLabel>
              <Select name="position" value={formValues.position} onChange={handleChange}>
                <MenuItem value="top">Top</MenuItem>
                <MenuItem value="bottom">Bottom</MenuItem>
                <MenuItem value="left">Left</MenuItem>
                <MenuItem value="right">Right</MenuItem>
                <MenuItem value="center">Center</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField fullWidth label="Content" multiline rows={3} name="content" value={formValues.content} onChange={handleChange} />
          </Grid>

          <Grid item xs={6}>
            <TextField fullWidth label="Number" type="number" name="number" value={formValues.number} onChange={handleChange} />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}>
          <Button type="submit" variant="contained" color="primary" sx={{ marginRight: 2 }}>
            Submit
          </Button>
          <Button variant="outlined" color="secondary" onClick={props.handleClose}>
            Cancel
          </Button>
        </Box>
      </form>

              <Snackbar
                            open={snackbar.open}
                            autoHideDuration={6000}
                            onClose={() => setSnackbar({ ...snackbar, open: false })}
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            sx={{zIndex:'100'}}
                           >
                          <Alert
                           onClose={() => setSnackbar({ ...snackbar, open: false })}
                           severity={snackbar.severity}
                            variant="filled"
                              >
                          {snackbar.message}
                            </Alert>
                         </Snackbar>
    </Box>
  );
};

export default OTTFingerprint;
